<button
  type="button"
  class="knowledge-base-bubble"
  [title]="'SIDEBAR.KNOWLEDGE_BASE' | translate"
  [attr.aria-label]="'SIDEBAR.KNOWLEDGE_BASE' | translate"
>
  <img [src]="iconPath" alt="" />
</button>
